import { render, staticRenderFns } from "./GigyaModalOverlay.vue?vue&type=template&id=22395d5e&"
import script from "./GigyaModalOverlay.vue?vue&type=script&lang=js&"
export * from "./GigyaModalOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports